import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textTruncate',
  standalone: false
})
export class TextTruncatePipe implements PipeTransform {

  transform(value: string, args: any): any {
    if (!value) {
      return value;
    }
    return `${value.substring(0, 100)}`;
  }

}
